/**
 * Base URL for the Express API. Set at build time via REACT_APP_API_URL.
 *
 * - Production builds: use .env.production (no localhost fallback).
 * - Development: if REACT_APP_API_URL is unset, defaults to http://localhost:4000.
 */
function trimTrailingSlashes(s) {
  return s.replace(/\/+$/, '');
}

/**
 * fetch() requires an absolute URL with a scheme. A value like `api.example.com` (no `https://`)
 * becomes a path-relative URL and hits the static site host → 404 on `/api/...`.
 */
function normalizeApiBase(raw) {
  const s = String(raw).trim();
  if (s === '') return '';
  if (/^https?:\/\//i.test(s)) return trimTrailingSlashes(s);
  if (/^localhost\b/i.test(s) || /^127\.0\.0\.1\b/.test(s)) {
    return trimTrailingSlashes(`http://${s}`);
  }
  return trimTrailingSlashes(`https://${s}`);
}

export function getApiBase() {
  const raw = process.env.REACT_APP_API_URL;
  if (raw != null && String(raw).trim() !== '') {
    return normalizeApiBase(raw);
  }
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:4000';
  }
  // Production build opened on localhost without .env — still use local API for dev smoke tests
  if (typeof window !== 'undefined') {
    const h = window.location.hostname;
    if (h === 'localhost' || h === '127.0.0.1') {
      return 'http://localhost:4000';
    }
    // If REACT_APP_API_URL was missing at build time, relative /api/... hits www and returns 404.
    // Same-origin shop on www → API on api. subdomain (Gem Fashion production).
    if (process.env.NODE_ENV === 'production' && (h === 'www.gemplexdebug.in' || h === 'gemplexdebug.in')) {
      return 'https://api.gemplexdebug.in';
    }
  }
  return '';
}

export const API_BASE = getApiBase();
